export default {
  // Only reflects an explicitly selected branch filter. No OTC default:
  // the branch stock filter must not be preselected (DEV-58090).
  activeWhs: (state) => state?.activeFilters?.whs?.[0],
};
